import React from 'react';

const FilterClearButton = ({ show, onClick }) => (
  <i className="fa fa-times" style={{ marginLeft: '1%' }} onClick={onClick} hidden={!show} />
);

export default FilterClearButton;
